import {urlGenerator} from "../../../common/Helper/AxiosHelper";
import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {leaveRequestStatusBuild} from "../View/Leave/Helper/Helper";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            urlGenerator,
            options: {
                name             : this.$t('tag'),
                url              : `${TENANT_BASE_URL}app/interview-tag?type=0,1,2`,
                showHeader       : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                columns          : [
                    {
                        title    : this.$t('actions'),
                        type     : 'action',
                        key      : 'id',
                        isVisible: true
                    },
                    {
                        title   : this.$t('type'),
                        type    : 'custom-html',
                        key     : 'type',
                        modifier: (value, row) => {
                            if (value === 0) {
                                return this.$t('jobs') + ' & ' + this.$t('candidate')
                            }
                            if (value === 1) {
                                return this.$t('jobs')
                            }
                            if (value === 2) {
                                return this.$t('candidate')
                            }
                            if (value === 3) {
                                return this.$t('finance')
                            }
                            if (value === 4) {
                                return this.$t('attendance')
                            }
                        }
                    },
                    {
                        title    : this.$t('title'),
                        type     : 'text',
                        key      : 'title',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('remark'),
                        type     : 'text',
                        key      : 'remark',
                        isVisible: true,
                    },
                ],
                filters          : [],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : true,
                orderBy          : 'desc',
                actionType       : 'default',
                actions          : [
                    {
                        title   : this.$t('edit'),
                        icon    : 'edit',
                        type    : 'modal',
                        modifier: row => this.$can('update_interview_tag')
                    },
                    {
                        title    : this.$t('delete'),
                        icon     : 'trash-2',
                        type     : 'modal',
                        component: 'app-confirmation-modal',
                        modalId  : 'app-confirmation-modal',
                        url      : `${TENANT_BASE_URL}app/interview-tag/`,
                        name     : 'delete',
                        modifier : row => this.$can('delete_interview_tag')
                    }
                ],
            }
        }
    },
}